//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  import axios from 'axios';

  export default {
    data() {
      return {
        loan: {
          value: 1000,
          min: 400,
          max: 3000,
          interval: 100
        },
        paymentTime: {
          value: 2,
          min: 1,
          interval: 0.5
        },
        currentInstallment: 0,
        currentTotal: 0,
        installments: null,
        totals: null,
        pressInterval: false
      }
    },
    mounted() {
      this.defaultValues();
      window.setTimeout(this.handleInput(), 5000);
      //this.fetchData();
      var app = this;
      document.body.addEventListener('click', function(event) {
        var id = event.target.id;
        if (id != 'loan-value' && id != 'loan-text-input' && !document.getElementById('loan-text-input').classList.contains('is-hidden')) {
          app.bodyClick('loan');
          document.getElementById('loan-text-input').classList.add('is-hidden');
          document.getElementById('loan-value').classList.remove('is-hidden');
        }
        if (id != 'time-value' && id != 'time-text-input' && !document.getElementById('time-text-input').classList.contains('is-hidden')) {
          app.bodyClick('time');
          document.getElementById('time-text-input').classList.add('is-hidden');
          document.getElementById('time-value').classList.remove('is-hidden');
        }
      });
    }, computed: {
      paymentTimeMax: function() {
        return this.getPaymentTimeMax();
      },
      monthlyPayment: function() {
        var monthly = 0;

        monthly = Number(this.currentInstallment);

        return monthly;
      },
      totalPayment: function() {
        var total = 0;

        total = Number(this.currentTotal);
        total = total;

        return total;
      },
    }, methods: {
	pmt:function(rate, nper, pv, fv, type) {
        if (!fv) fv = 0;
        if (!type) type = 0;
     
        if (rate === 0) return -(pv + fv)/nper;
     
        let pvif = Math.pow(1 + rate, nper);
        let pmt = rate / (pvif - 1) * -(pv * pvif + fv);
     
        if (type === 1) {
            pmt /= (1 + rate);
        };
     
        return pmt;
    },
    getMaturityRangeInMonths: function() {
        return [12, 18, 24, 30, 36];
    },
    getMaxMaturity: function() {
        return Math.max.apply(Math, this.getMaturityRangeInMonths());
    },
 	getPaymentsInYear: function() {
    	return 12;
	},
	getYearlyInterest: function() {
	    return 0.199;
	},
 	getMaturityInYears: function(maturity) {
    	return  maturity / this.getPaymentsInYear();
	},
	getServicingFee: function(amount) {
    	return amount * 0.01 * 30 / 100;
	},
	getMonthlyPricing: function(amount, maturity) {
        if (!amount || !maturity) {
            return '';
        }
        const interest = this.getYearlyInterest(); // Annual interest
        const years = this.getMaturityInYears(maturity); // Lifetime of loan (in years)
        const paymentsInYear = this.getPaymentsInYear();
        const fee = this.getServicingFee(amount);
        const result = this.pmt(
            interest / paymentsInYear,
            years * paymentsInYear,
            amount // Present value of loan
        ) - fee;

        return result * -1;
	},
	getTotal: function(monthlyPricing, maturity) {
	    if (!monthlyPricing || !maturity) {
    	    return '';
	    }
    	return maturity * monthlyPricing;
	},
	round(amount) {
    	// 100 = round with 2 decimals
	    // 10 = round with 1 decimal
	    let roundAmount = 100;
    	return Math.round( amount * roundAmount) / roundAmount;
	},
      isNumber: function(event) {
        var regex = /^[0-9.,\b]+$/;
        if (!regex.test(event.key) && event.key != 'Backspace' && event.key != 'Enter') {
          event.preventDefault();
        }
      },
      /*fetchData: function() {
        // https://production-public-api2.opr-finance.com/api/ostosraha/v1/pricelist
		
        axios.get('/app/themes/opr-ostosraha/resources/assets/scripts/pricelist.json')
          .then((response) => {
            this.installments = response.data.prices.tasaera;
            this.totals = response.data.prices.kustannukset;
          }).catch(error => {
            console.log(error.message);
            var fallback = require('../pricelist-backup.json');
            this.installments = fallback.prices.tasaera;
            this.totals = fallback.prices.kustannukset;
            window.setTimeout(this.handleInput(), 5000);
          })
      },*/
      defaultValues: function() {
        /*Get default values from DOM */
        var defaultValue = document.getElementById('default-value').textContent;
        var defaultTime = document.getElementById('default-time').textContent;

        if (defaultValue.length > 0) {
          defaultValue = parseInt(defaultValue);
          this.loan.value = defaultValue;
        }

        if (defaultTime.length > 0) {
          defaultTime = parseFloat(defaultTime);
          this.paymentTime.value = defaultTime;
        }
      },
      handleInput: function() {
        this.setPaymentTime();
        this.setCurrent();

        /* Timeout this so that the needed values have enough time to set before setting slider track color*/
        var app = this;
        setTimeout(function() {
          app.sliders();
        }, 30);
      },
      showInput: function(element) {
        if (element == 'loan') {
          var loanInput = document.getElementById('loan-input').getElementsByTagName('input')[0];
          loanInput.classList.remove('is-hidden');
          loanInput.value = this.loan.value;
          loanInput.focus();
          document.getElementById('loan-input').getElementsByTagName('span')[0].classList.add('is-hidden');

          /* Disable buttons to prevent user from breaking things on touch devices */
          this.disableButtons(); 
        } else if (element == 'time') {
          var timeInput = document.getElementById('time-input').getElementsByTagName('input')[0];
          timeInput.classList.remove('is-hidden');
          timeInput.value = this.paymentTime.value;
          timeInput.focus();
          document.getElementById('time-input').getElementsByTagName('span')[0].classList.add('is-hidden');

          this.disableButtons(); 
        }
      },
      /* Check text input validity when clicking body */
      bodyClick: function(type) {
        var parent = null;
        if (type == 'loan') {
          parent = document.getElementById('loan-input');
        } else if (type == 'time') {
          parent = document.getElementById('time-input');
        }
        var loanInput = document.getElementById('loan-input').getElementsByTagName('input')[0];
        var timeInput = document.getElementById('time-input').getElementsByTagName('input')[0];
        var loan = loanInput.value;
        var lmin = this.loan.min;
        var lmax = this.loan.max;
        var time = timeInput.value;
        var tmin = this.paymentTime.min;
        var tmax = this.getPaymentTimeMax();

        /* Validate loan input */
        if (parent.id == 'loan-input') {
          if (loan < lmin) {
            loanInput.value = lmin;
            this.loan.value = lmin;
          } else if(loan > lmax) {
            loanInput.value = lmax;
            this.loan.value = lmax;
          } else if (loan % 100 != 0) {
            var val = Math.ceil(loan/100)*100;
            loanInput.value = val;
            this.loan.value = val;
          } else {
            this.loan.value = loan;
          }
        }

        /* Validate time input */
        time = Number(time);
        if (parent.id == 'time-input') {
          if (time < tmin) {
            timeInput.value = tmin;
            this.paymentTime.value = tmin;
          } else if (time > tmax) {
            timeInput.value = tmax;
            this.paymentTime.value = tmax;
          } else if (time % 0.5 != 0) {
            var val = Math.round(time*2)/2;
            timeInput.value = val;
            this.paymentTime.value = val;
          } else {
            this.paymentTime.value = time;
          }
        }

        loanInput.classList.add('is-hidden');
        timeInput.classList.add('is-hidden');
        document.getElementById('loan-input').getElementsByTagName('span')[0].classList.remove('is-hidden');
        document.getElementById('time-input').getElementsByTagName('span')[0].classList.remove('is-hidden');
        this.handleInput();
        setTimeout(this.sliders, 100); // Timeout so the keypress has enough time to register

        this.enableButtons(); 
      },
      /* Check text input validity */
      handleTextInput: function(event) {
        if (event.key == 'Enter') {
          var parent = event.target.parentElement;
          var loanInput = document.getElementById('loan-input').getElementsByTagName('input')[0];
          var timeInput = document.getElementById('time-input').getElementsByTagName('input')[0];
          var loan = loanInput.value;
          var lmin = this.loan.min;
          var lmax = this.loan.max;
          var time = timeInput.value;
          var tmin = this.paymentTime.min;
          var tmax = this.getPaymentTimeMax();

          /* Validate loan input */
          if (parent.id == 'loan-input') {
            if (loan < lmin) {
              loanInput.value = lmin;
              this.loan.value = lmin;
            } else if(loan > lmax) {
              loanInput.value = lmax;
              this.loan.value = lmax;
            } else if (loan % 100 != 0) {
              var val = Math.ceil(loan/100)*100;
              loanInput.value = val;
              this.loan.value = val;
            } else {
              this.loan.value = loan;
            }
          }

          /* Validate time input */
          time = Number(time);
          if (parent.id == 'time-input') {
            if (time < tmin) {
              timeInput.value = tmin;
              this.paymentTime.value = tmin;
            } else if (time > tmax) {
              timeInput.value = tmax;
              this.paymentTime.value = tmax;
            } else if (time % 0.5 != 0) {
              var val = Math.round(time*2)/2;
              timeInput.value = val;
              this.paymentTime.value = val;
            } else {
              this.paymentTime.value = time;
            }
          }

          loanInput.classList.add('is-hidden');
          timeInput.classList.add('is-hidden');
          document.getElementById('loan-input').getElementsByTagName('span')[0].classList.remove('is-hidden');
          document.getElementById('time-input').getElementsByTagName('span')[0].classList.remove('is-hidden');
          this.handleInput();
          setTimeout(this.sliders, 100); // Timeout so the keypress has enough time to register

          /* Re-enable buttons */
          this.enableButtons(); 
        }
      },
      sliders: function() {
        /* Set range input track color when changing values */
        var loanSlider = document.getElementById('loan-slider');
        var timeSlider = document.getElementById('time-slider');

        var val = (loanSlider.value - loanSlider.min) / (loanSlider.max - loanSlider.min);
        loanSlider.style.backgroundImage = '-webkit-gradient(linear, left top, right top, color-stop(' + val + ', #6cb644), color-stop(' + val + ', #446134))';

        val = (timeSlider.value - timeSlider.min) / (timeSlider.max - timeSlider.min);
        timeSlider.style.backgroundImage = '-webkit-gradient(linear, left top, right top, color-stop(' + val + ', #6cb644), color-stop(' + val + ', #446134))';
      },
      setCurrent: function() {
        /* Set current monthly installment and total values based on input values */
        var value = this.loan.value;
        var time = this.paymentTime.value * 12; // Needs to be multiplied by 12 and 10 because that's how they're stored in JSON data
		var monthlyPricing = this.getMonthlyPricing(value, time);
	    this.currentInstallment = this.round(monthlyPricing).toFixed(2);
    	this.currentTotal = this.round(this.getTotal(monthlyPricing, time)).toFixed(2);
      },
      getPaymentTimeMax: function() {
        /* Payment time max value based on selected loan value */
        return 36/12;
      },
      setPaymentTime: function() {
        var paymentTimeMax = this.getPaymentTimeMax();
        if (this.paymentTime.value > paymentTimeMax) {
          this.paymentTime.value = paymentTimeMax;
        }
      },
      /*
       * Add/subtract methods for slider buttons
       * Using intervals because of long touch/mousepress
       * Disable all other buttons to prevent multiple buttons being pressed at the same time
       */
      subtractLoan: function() {
        if (!document.getElementById('loan-minus').disabled) {
          var app = this;
          document.getElementById('loan-plus').disabled = true;
          document.getElementById('loan-minus').disabled = false;
          document.getElementById('time-plus').disabled = true;
          document.getElementById('time-minus').disabled = true;
          document.getElementById('loan-slider').disabled = true;
          document.getElementById('time-slider').disabled = true;
          this.pressInterval = setInterval(function() {
            if (app.loan.value > app.loan.min) {
              app.loan.value -= Number(app.loan.interval);
            }
            app.handleInput();
          }, 60);
        }
      },
      addLoan: function() {
        if (!document.getElementById('loan-plus').disabled) {
          var app = this;
          document.getElementById('loan-plus').disabled = false;
          document.getElementById('loan-minus').disabled = true;
          document.getElementById('time-plus').disabled = true;
          document.getElementById('time-minus').disabled = true;
          document.getElementById('loan-slider').disabled = true;
          document.getElementById('time-slider').disabled = true;
          this.pressInterval = setInterval(function() {
            if (app.loan.value < app.loan.max) {
              app.loan.value = Number(app.loan.value) + Number(app.loan.interval);
            }
            app.handleInput();
          }, 60);
        }
      },
      subtractPaymentTime: function() {
        if (!document.getElementById('time-minus').disabled) {
          var app = this;
          document.getElementById('loan-plus').disabled = true;
          document.getElementById('loan-minus').disabled = true;
          document.getElementById('time-plus').disabled = true;
          document.getElementById('time-minus').disabled = false;
          document.getElementById('loan-slider').disabled = true;
          document.getElementById('time-slider').disabled = true;
          this.pressInterval = setInterval(function() {
            if (app.paymentTime.value > app.paymentTime.min) {
              app.paymentTime.value -= Number(app.paymentTime.interval);
            }
            app.handleInput();
          }, 60);
        }
      },
      addPaymentTime: function() {
        if (!document.getElementById('time-plus').disabled) {
          var app = this;
          document.getElementById('loan-plus').disabled = true;
          document.getElementById('loan-minus').disabled = true;
          document.getElementById('time-plus').disabled = false;
          document.getElementById('time-minus').disabled = true;
          document.getElementById('loan-slider').disabled = true;
          document.getElementById('time-slider').disabled = true;
          this.pressInterval = setInterval(function() {
            if (app.paymentTime.value < app.getPaymentTimeMax()) {
              app.paymentTime.value = Number(app.paymentTime.value) + Number(app.paymentTime.interval);
            }
            app.handleInput();
          }, 60);
        }
      },
      /* Stop add/subtract intervals */
      stop: function() {
        clearInterval(this.pressInterval);
        this.pressInterval = false;
        this.enableButtons();
        document.getElementById('loan-slider').disabled = false;
        document.getElementById('time-slider').disabled = false;
      },
      enableButtons: function() {
        /* Enable all buttons */
        document.getElementById('loan-plus').disabled = false;
        document.getElementById('loan-minus').disabled = false;
        document.getElementById('time-plus').disabled = false;
        document.getElementById('time-minus').disabled = false;
      },
      disableButtons: function() {
        /* Disable all buttons */
        document.getElementById('loan-plus').disabled = true;
        document.getElementById('loan-minus').disabled = true;
        document.getElementById('time-plus').disabled = true;
        document.getElementById('time-minus').disabled = true;
      }
    }, components: {
    }
  }



// WEBPACK FOOTER //
// ./scripts/components/Calculator.vue